import { useCallback } from 'react';
import { FETCH_PORTFOLIO_REPORTS } from '../queries';
import {
  buildPortfolioReportsSearchVariables,
  mapPortfolioReportSearchHits,
  TOOLBAR_SEARCH_MIN_CHARS,
} from '../utils/portfolioSearchOptions';
import { useLazySearchOptions } from './useLazySearchOptions';

export function usePortfolioReportSearchOptions({
  organizationId,
  canReadRepCode,
}: {
  organizationId?: string;
  canReadRepCode: boolean;
}) {
  const buildVariables = useCallback(
    (trimmed: string) =>
      buildPortfolioReportsSearchVariables(
        organizationId as string,
        trimmed,
        canReadRepCode,
      ),
    [organizationId, canReadRepCode],
  );

  const mapResults = useCallback(
    (
      data:
        | { fetchPortfolioReports?: { portfolioReports?: unknown } }
        | undefined,
    ) =>
      mapPortfolioReportSearchHits(
        data?.fetchPortfolioReports?.portfolioReports as Parameters<
          typeof mapPortfolioReportSearchHits
        >[0],
      ),
    [],
  );

  return useLazySearchOptions({
    query: FETCH_PORTFOLIO_REPORTS,
    minChars: TOOLBAR_SEARCH_MIN_CHARS,
    isEnabled: Boolean(organizationId),
    buildVariables,
    mapResults,
    errorMessageKey: 'filters.portfolioSearchFailed',
  });
}
